import {
  AppBar,
  Button,
  CardMedia,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Slide,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { TransitionProps } from "@mui/material/transitions";
import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import zIndex from "@mui/material/styles/zIndex";

// import { Slide as Slider } from "react-slideshow-image";
// import "react-slideshow-image/dist/styles.css";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ProductInformation({
  currentContent,
  open,
  setOpen,
}: any) {
  const matches = useMediaQuery("(min-width:600px)");
  const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  return (
    <Dialog
      fullScreen={matches ? false : true}
      fullWidth={true}
      maxWidth="lg"
      open={open}
      onClose={() => setOpen(false)}
      // TransitionComponent={Transition}
      style={{ borderRadius: "0px", cursor: "auto" }}
    >
      <DialogContent style={{ width: "100%" }}>
        {isMobileDevice ? (
          <IconButton
            edge="start"
            color="primary"
            onClick={() => setOpen(false)}
            aria-label="close"
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "#dbd8d85e",
              zIndex: 10,
              height: "100px",
              width: "100px",
            }}
          >
            <CloseRoundedIcon sx={{ height: "80px", width: "80px" }} />
          </IconButton>
        ) : (
          <IconButton
            edge="start"
            color="primary"
            onClick={() => setOpen(false)}
            aria-label="close"
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "#dbd8d85e",
              zIndex: 10,
            }}
          >
            <CloseRoundedIcon />
          </IconButton>
        )}

        {currentContent && (
          <Grid
            container
            xs={12}
            justifyContent={"space-evenly"}
            spacing={matches ? 3 : 1}
            style={{ paddingTop: matches ? 10 : 40 }}
          >
            <Grid item xs={12} sx={{ display: { xs: "block", sm: "none" } }}>
              <Typography
                variant={matches ? "h4" : "h5"}
                style={{
                  fontSize: matches || isMobileDevice ? "4em" : "0.8em",
                }}
                align={"left"}
              >
                {currentContent.title}
              </Typography>
            </Grid>
            {/* <Grid
              item
              xs={12}
              sm={12}
              md={7}
              lg={8}
              style={{
                width: "100%",
                height: "100%",
              }}
            >
              {currentContent.images ? (
                <Slider
                  slidesToShow={1}
                  {...{
                    dots: false,
                    infinite: true,
                    arrows: true,
                    speed: 1200,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 3500,
                  }}
                  slidesPerRow={1}
                >
                  {currentContent.images.map((i: string) => {
                    return (
                      <div>
                        <CardMedia
                          sx={{ height: matches ? "60vh" : "30vh" }}
                          image={i}
                          title={currentContent.title}
                        />
                      </div>
                    );
                  })}
                </Slider>
              ) : (
                <img
                  style={{
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                  src={currentContent.image}
                  alt={currentContent.title}
                />
              )}
            </Grid> */}

            <Grid
              item
              xs={10}
              // xs={12}
              // sm={12}
              // md={5}
              // lg={4}
              container
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid item xs={12} sx={{ display: { xs: "none", sm: "block" } }}>
                <Typography
                  variant="h4"
                  align={"left"}
                  style={{
                    fontSize: matches || isMobileDevice ? "4em" : "0.8em",
                  }}
                >
                  {currentContent.title}
                </Typography>
                <br />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  variant="body2"
                  align={"left"}
                  style={{
                    fontSize: matches || isMobileDevice ? "2em" : "0.8em",
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: currentContent.description,
                    }}
                  />
                </Typography>
              </Grid>

              {currentContent.link && (
                <Grid
                  item
                  xs={12}
                  container
                  alignItems="center"
                  justifyContent="center"
                  style={{ margin: "20px 0" }}
                >
                  <Button
                    variant="outlined"
                    style={{
                      textTransform: "none",
                    }}
                    target="_blank"
                    href={currentContent.link}
                  >
                    Learn More
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
}
